module.exports = __webpack_public_path__ + "static/media/nest1.af819dc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flexhouse/nest1.jpg
// module id = 95
// module chunks = 0